module.exports = __webpack_public_path__ + "a014feb20b0cb4e82dcac92c340d6c05.png";